// const videoList = [
//   {
//     url: "video/front.mp4",
//     isPlaying: true,
//   },
//   {
//     url: "video/left.mp4",
//     isPlaying: true,
//   },
//   {
//     url: "video/right.mp4",
//     isPlaying: true,
//   },
//   {
//     url: "video/rear.mp4",
//     isPlaying: true,
//   },
// ];

// export default videoList;

const videoList = [
  {
    url: "video/Bird_view_updated.mp4",
    isPlaying: true,
  },

  {
    url: "video/Right_view_updated.mp4",
    isPlaying: true,
  },
  {
    url: "video/right_side_updated.mp4",
    isPlaying: true,
  },
  {
    url: "video/Driver_view_updated.mp4",
    isPlaying: true,
  },
];

export default videoList;
